<template lang="pug">
  .payment
    .payment__title.button.button_secondary-round.active.uppercase.semi-bold {{$t('common.order')}} №{{id}}
    .payment__delivery
      .payment__delivery_header
        .payment__delivery_header--step 1
        .payment__delivery_header--title {{ $t('payment.obtainMethod') }}
        .payment__delivery_header--timer(v-if="order") {{timer | moment('mm:ss')}}
      .payment__delivery_input
        label.payment__delivery_input--primary-label {{$t('payment.phoneSend')}}
        input.payment__delivery_input--input.input(v-model="phone",
        v-mask="'+ (###)-##-###-#######'", disabled)

        label.payment__delivery_input--primary-label {{$t('payment.email')}}
        input.payment__delivery_input--input.input(v-model="email")
        label.payment__delivery_input--secondary-label {{$t('payment.also')}}
      .payment__delivery_amount(v-if="order")
        template(v-if="order.total_amount_int")
          .payment__delivery_amount--balence
            label.checkbox.popup__checkbox
              input(type="checkbox", v-model="usePoints")
              span.checkbox__text
                span {{$t('payment.pointsPay')}} ({{$t('payment.yourPoints').replace(/%balance%/gi, balance)}})
          .payment__delivery_amount--title {{ $t('payment.total') }}:
          .payment__delivery_amount--line {{ $t('payment.orderCost') }}: {{order.amount_int / 100}} {{ (getLayout && getLayout.currency_symbol) ? getLayout.currency_symbol : $t('currency.rub') }}
          .payment__delivery_amount--line {{ $t('payment.serviceFee') }}: {{order.commission / 100}} {{ (getLayout && getLayout.currency_symbol) ? getLayout.currency_symbol : $t('currency.rub') }}
          .payment__delivery_amount--line(v-if="order.totalDiscount")
            | {{ $t('payment.discount') }}: {{order.totalDiscount / 100}} {{ (getLayout && getLayout.currency_symbol) ? getLayout.currency_symbol : $t('currency.rub') }}
          .payment__delivery_amount--amount {{ $t('payment.total') }}: {{ currency(toPaySum) }}
        template(v-else-if="order.total_amount_int == 0")
          button.btn.button_primary(@click="selectSystem(freeBalance)") {{$t('payment.get')}}
    // .payment__list(v-if="order && payments && order.amount_int > 0")
      .payment__delivery_header
        .payment__delivery_header--step 2
        .payment__delivery_header--title Способ оплаты
      .payment__list_items
        .payment__list_items--item(v-for="payment in payments",
                                   v-if="payment.orderType !== 'balance'")
          .payment__part
            .payment__part-image
              img(:src="payment.logoUrl")
            .payment__part-title {{payment.name}}
          .payment__part
            .payment__part-title К оплате: {{order.amount_int / 100}} руб.
            .payment__part-link
              button.btn.button_primary-outline(@click="selectSystem(payment)") Оплатить
    .payments.overflow-horizaontal
          template(v-for="(payment, index) in payments")
            .payment(v-if="payment.type.match('BePaid')", v-bind:class="{'active': index == selectPaymentIndex, 'thiscard': payment.card}", @click="selectPaymentIndex = index")
              .image
                img(:src="payment.logoUrl", v-if="!payment.card")
                img(:src="creditCardPng", v-if="payment.card")
              .content#cardContent
                .name {{ payment.name }}
                .description#descr(v-html="payment.shortDescription")
          //.empty-block
    button.btn.yellow(@click="selectSystem(payments[selectPaymentIndex])", v-if="order && order.id && !order.status")
      span(v-if="toPaySum == 0") {{$t('Получить')}}
      span(v-if="toPaySum > 0 && !this.usePoints") {{ $t('payment.pay') }} {{ currency(toPaySum) }}
      span(v-if="toPaySum > 0 && this.usePoints") {{ $t('payment.payExtra') }} {{ currency(toPaySum) }}
</template>
<script>
import { mapGetters } from 'vuex';
import config from '@/api/config';
import API from '@/api/api';
const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'BYN' });
export default {
  props: ['id'],
  data() {
    return {
      selectPaymentIndex: 0,
      cabinet: null,
      profile: null,
      phone: this.profile ? this.profile.phone : null,
      email: this.profile ? this.profile.email : null,
      balance: this.profile ? this.profile.balance : null,
      payments: null,
      order: null,
      timer: 0,
      method: null,
      usePoints: 0,
      interval: null,
      freeBalance: {
        orderType: 'balance',
        paymentId: 4,
        target: 0,
        type: 'balance',
      },
    };
  },
  computed: {
    ...mapGetters({
      getCabinet: 'getCabinet',
      getLayout: 'getLayout',
    }),
    toPaySum() {
      if (this.order) {
        let toPay = this.order.amount_int + this.order.commission - this.order.discount;
        if (this.usePoints) {
          toPay = this.order.amount_int - (this.profile.balance * 10);
        }
        return toPay < 0 ? 0 : toPay;
      }
      return 0;
    },
    selectPayment() {
      return this.order && this.payments ? (this.payments[this.selectPaymentIndex] || null) : null;
    },
  },
  mounted() {
    this.cabinet = this.getCabinet;
    if (this.cabinet) {
      this.profile = this.cabinet.profile;
      this.phone = this.cabinet.profile.phone;
      this.email = this.cabinet.profile.email;
      this.balance = this.cabinet.profile.balance;
    }
    this.getOrder();
    this.getPayments();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    async getPayments() {
      const data = await API.getPayments({ order_id: this.id });
      if (data) {
        this.payments = data;
      }
    },
    currency(cost) {
      // eslint-disable-next-line
      return formatter.format(cost / 100).replace('BYN', '').trim() + ((this.getLayout && this.getLayout.currency_symbol) ? this.getLayout.currency_symbol : this.$t('currency.rub'));
    },
    async getOrder() {
      const data = await API.getOrder(this.id, (localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ru'));
      if (data) {
        this.order = data;
        if (data.coupons && data.coupons.length) {
          this.method = 'sms';
        } else {
          this.method = 'email';
        }
        this.interval = setInterval(() => {
          if (this.order.expired_at < Date.now() / 1000) {
            global.alert('Время оформления заказа вышло');
            clearInterval(this.interval);
            this.$router.push('/');
          }
          this.timer = this.order.expired_at - Math.floor(Date.now() / 1000);
          // console.log(this.order.expiration_at, Math.floor(Date.now() / 1000));
        }, 1000);
      }
    },

    async selectSystem(payment) {
      if (this.email && this.email.length) {
        let params;
        if (this.method === 'sms') {
          params = {
            'params[phone]': this.phone,
            usePoints: this.usePoints ? 1 : 0,
            paymentId: payment.paymentId,
            view_type: 'cabinet',
          };
        }
        if (this.method === 'email') {
          params = {
            'params[email]': this.email,
            usePoints: this.usePoints ? 1 : 0,
            paymentId: payment.paymentId,
            type: payment.orderType,
            view_type: 'cabinet',
          };
        }

        const data = await API.acceptOrder(this.id, params);
        if (data) {
          if (payment.type === 'erip') {
            const success = await API.getErip(this.id, () => {
              global.alert('Произошла ошибка сервера, попробуйте позже');
            });
            if (success) {
              this.$router.push({ name: 'erip', params: { orderId: this.id } });
            }
            return;
          }
          const Config = {
            baseUrl: config.baseUrl,
          };
          let url = `${Config.baseUrl}/api/v2/frame/payment/${payment.type}?id=${this.id}&register=1&view_type=cabinet&redirect_to=https://cabinet.24afisha.by/?lang=ru/#/thank-you`;
          if (payment.card) {
            url += `&card=${payment.card}`;
          }
          window.open(url, '_top');
        }
        return;
      }
      global.alert('введите необходимые данные');
    },
  },
  watch: {
    getCabinet(val) {
      this.cabinet = val;
      this.profile = val.profile;
      this.phone = val.profile.phone;
      this.email = val.profile.email;
      this.balance = val.profile.balance;
    },
  },
};
</script>
<style lang="scss">
.payment{
  &__title{
    margin-bottom: 1rem;
  }
  &__delivery{
    padding: 1.5rem 1rem;
    background: #f6f6f6;
    &_header{
      position: relative;
      display: flex;
      &--step{
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffcc00;
        border-radius: 15px;
        font-size: 14;
        font-weight: 500;
        height: 30px;
        width: 30px;
      }
      &--title{
        padding-left: 1rem;
        line-height: 30px;
        font-size: 16px;
        font-weight: 600;
      }
      &--timer{
        background: url('~@/assets/img/timer.png') no-repeat 0 .25rem;
        position: absolute;
        font-size: 16px;
        font-weight: 600;
        padding-left: 20px;
        line-height: 30px;
        right: 0;
      }
    }
    &_input{
      padding: 1rem 3rem;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      &--primary-label{
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 1rem;
      }
      &--input{
        padding-left: 1rem;
        max-width: 400px;
        margin-bottom: 1rem;
        height: 40px;
        font-size: 14px;
      }
      &--secondary-label{
        font-size: 12px;
        color: #aaa;
      }
    }
    &_amount{
      padding: 1rem 3rem;
      &--title{
        font-size: 16px;
        font-weight: 600;
        padding-bottom: .75rem;
      }
      &--line{
        font-size: 12px;
        padding-bottom: .5rem;
      }
      &--amount{
        margin-top: .25rem;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
  &__list {
    padding-top: 2rem;
    &_items {
      border-bottom: 1px solid #ddd;
      padding-top: 1rem;
      &--item{
        .payment__part-image {
          img {
            max-width: 100px;
          }
        }
        padding: 2rem 0;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #ddd;
        .payment__part{
          display: flex;
          justify-content: center;
          align-items: center;
          .payment__part-title{
            padding: 0 2rem;
            font-size: 12px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
.payments {
  padding: 0;
  margin: 0;

  .payment {
    margin: 0 0 15px 0;
    background-color: white;
    display: inline-table;
    // display: block;
    // float: left;
    border: 1px solid #dad6d6;
    border-radius: 5px;
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    height: 190px;
    padding: 10px;
    text-align: center;

    .image {
      text-align: center;
      width: 100%;
      height: 60px;

      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        max-width: 100%;
        max-height: 50px;
      }
    }

    .content {
      overflow: hidden;
      height: 110px;

      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .name {
        // color: #858585;
        font-size: 13px;
        line-height: 14px;
      }
    }

    &.active {
      border: 1px #fff solid;
      -webkit-box-shadow: 0px 0px 0px 3px #f3e418;
      -moz-box-shadow: 0px 0px 0px 3px #f3e418;
      box-shadow: 0px 0px 0px 3px #f3e418;
    }
  }
}

.empty-block {
  width: 18px;
  height: 32px;
  display: inline-table;
}
.overflow-horizaontal {
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  padding: 5px 5px!important;
  overflow: auto;
}
.yellow {
  background: #f3e418;
  color: #2f2f2f !important;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  align-items: center;
  border: none;
  border-radius: 5px;
  box-shadow: 0 2px 4pxrgba(0,0,0,.1);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  justify-content: center;
  line-height: 48px;
  min-height: 30px;
  min-width: 48px;
  padding: 0 12px;
  text-decoration: none;
  white-space: nowrap;
}
#descr {
  font-size: 12px;
  color: #858585;
}
#cardContent {
  padding: 0;
}
</style>
